import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CadastroService } from '../../../../services/cadastro.service';
import { Cliente, ClienteDTO } from '../../../../models/cadastro.model';
import { NgxMaskPipe } from 'ngx-mask';

@Component({
  selector: 'app-clientes',
  standalone: true,
  imports: [CommonModule, FormsModule, NgxMaskPipe],
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.css']
})
export class ClientesComponent implements OnInit {
  clientes: ClienteDTO[] = [];
  filteredClientes: ClienteDTO[] = [];
  paginatedClientes: ClienteDTO[] = [];
  
  searchTerm = '';
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 1;

  // Pagination
  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  constructor(
    private cadastroService: CadastroService, 
    private router: Router,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.loadClientes();
  } 

  loadClientes(): void {
    this.cadastroService.getClientes().subscribe(data => {
      this.clientes = data;
      this.search();
    });
  }

  search(): void {
    this.filteredClientes = this.clientes.filter(cliente =>
      cliente.nomeRazaoSocial.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      (cliente.nomeFantasia && cliente.nomeFantasia.toLowerCase().includes(this.searchTerm.toLowerCase())) ||
      cliente.cpfCnpj.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
    this.totalPages = Math.max(1, Math.ceil(this.filteredClientes.length / this.itemsPerPage));
    this.setPage(1);
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.filteredClientes.length);
    this.paginatedClientes = this.filteredClientes.slice(startIndex, endIndex);
    this.updatePageNumbers();
  }

  updatePageNumbers(): void {
    const halfPages = Math.floor(this.maxPagesToShow / 2);
    this.startPage = Math.max(1, this.currentPage - halfPages);
    this.endPage = Math.min(this.totalPages, this.startPage + this.maxPagesToShow - 1);

    if (this.endPage - this.startPage + 1 < this.maxPagesToShow) {
      this.startPage = Math.max(1, this.endPage - this.maxPagesToShow + 1);
    }

    this.pages = Array.from({ length: (this.endPage - this.startPage) + 1 }, (_, i) => this.startPage + i);
  }

  novoCliente(): void {
    this.router.navigate(['/home', 'cadastro-cliente-manutencao']);
  }

  editarCliente(id: number): void {
    this.router.navigate(['/home', 'cadastro-cliente-manutencao', id]);
  }

  verVendasCliente(id: number): void {
    this.router.navigate(['/home', 'cadastro-cliente-vendas', id]);
  }

  deleteCliente(id: number): void {
    if (confirm('Tem certeza que deseja excluir este cliente?')) {
      this.cadastroService.deleteCliente(id).subscribe(() => {
        this.toastr.success('Cliente excluído com sucesso!');
        this.loadClientes();
      }, error => {
        this.toastr.error('Erro ao excluir cliente.');
      });
    }
  }
}
